<template>
  <section class="spartan-home sp-bio">
    <SpartanHeader />

    <div class="container-wide">
      <div class="content">
        <SpartanNavigation />

        <div class="banner">
          <picture>
            <source
              media="(max-width: 480px)"
              srcset="../assets/spartan-bio-square.jpg"
              alt=""
            />
            <source
              media="(min-width:481px)"
              srcset="../assets/spartan-banners/spartan-bio.jpg"
              alt=""
            />
            <img src="../assets/spartan-banners/spartan-bio.jpg" alt="" />

          </picture>
          <!-- <img src="../assets/spartan-banners/spartan-bio.jpg" alt="" /> -->
        </div>

        <div class="copy">
          <figure class="bio-picture fl-left">
            <img
              src="@/assets/people/BryantRose.jpg"
              alt="Bryant Rose - Spartan Builders"
              width="216"
              height="307"
            />
          </figure>

          <h2>Bryant Rose — Builder</h2>
          <p>
            Bryant has had a love affair with design and building for the past
            25 years. Working in both commercial and residential construction in
            a variety of trade skills, he has earned a reputation for quality
            work at a fair value, done on time and within budget.
          </p>
          <p>
            Beginning in 1995, his start in the business was installing
            cabinetry and millwork on Military housing, multi family apartments,
            and single family residential homes. That experience provided him a
            solid foundation of what it takes to put projects together.
          </p>
          <p>
            From there he grew into a General Contractor working for Big Box
            retailers as a trusted service provider, managing the installation
            of thousands of projects, ranging from exteriors, roofing and
            windows, to complete kitchen and bathroom renovations. During that
            same period, starting around 1999, Bryant combined his love of
            design, and an eye for detail, and began building his own custom
            homes. Then in 2009, he turned his focus to the commercial
            contracting side of the business, focusing on small, and medium
            sized construction projects.
          </p>
          <p>
            As the owner of Spartan Builders, he is focused daily on serving the
            needs of commercial property managers, real estate brokers,
            condominium associations, building owner/investors, and private
            clients to complete whatever type of construction project need they
            may have.
          </p>

          <p>
            Sometimes, the client’s like to go play golf, or grab a bite to eat.
            He is always available to do that, too.
          </p>
        </div>
      </div>
    </div>

    <SpartanFooter />
  </section>
</template>

<script>
import SpartanHeader from "@/components/SpartanHeader.vue";
import SpartanNavigation from "@/components/SpartanNavigation.vue";
import SpartanFooter from "@/components/SpartanFooter.vue";

export default {
  name: "SpartanHome",
  components: {
    SpartanHeader,
    SpartanNavigation,
    SpartanFooter
  }
};
</script>

<style lang="scss">
.content {
  background: #7a7a75;
  min-height: 50vh;
}

.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #fff;
}

.banner {
  width: 100%;
}

.banner > img,
.banner > picture {
  width: 100%;
  height: auto;
}
</style>
